import { Text, Input, Stack } from '@pairy/pds-react';
import { ChangeEvent, KeyboardEvent } from 'react';

import RequiredMark from '../RequiredMark';
import { FormRecordProps } from '../index.type';
import * as Styled from '../index.styles';

interface Props extends FormRecordProps<number> {
  title: string;
  isRequired: boolean;
  description?: string;
  placeholder: string;
  min?: number;
  max?: number;
}

const NumberInput = ({
  id,
  title,
  description,
  isRequired,
  placeholder,
  min = 0,
  max = 200,
  value,
  translateKoToEn,
  handleChangeWithId,
}: Props) => {
  const isBelowMinValue = value < min && Boolean(value);
  const invalidFeedback = `${min}보다 큰 값을 입력해주세요.`;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (Number(e.target.value) > max) {
      handleChangeWithId(id, max);
      return;
    }

    handleChangeWithId(id, Number(e.target.value));
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.stopPropagation();
    }
  };

  return (
    <Stack direction="column" gap={4}>
      <Stack gap={4} alignItems="center">
        <Styled.KeepAllText variant="md-semibold" color="black">
          {title}
        </Styled.KeepAllText>
        {isRequired && <RequiredMark translateKoToEn={translateKoToEn} />}
      </Stack>
      {description && <Styled.KeepAllText>{description}</Styled.KeepAllText>}
      <Input
        width="100%"
        type="number"
        max={max}
        min={min}
        placeholder={placeholder}
        isError={isBelowMinValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={String(value)}
      />
      {isBelowMinValue && (
        <Text variant="sm-medium" color="cerise_500">
          {invalidFeedback}
        </Text>
      )}
    </Stack>
  );
};

export default NumberInput;
